import React from "react";
import styles from "./Footer.module.css";
import HorizontalLine from "../../../../common/components/horizontalLine/HorizontalLine";
import PuiTypography from "../../../../components/elements/PuiTypography";
import useResponsive from "../../../../common/useResponsive";

function Footer() {
  const { isMobile } = useResponsive();
  return (
    <footer className={styles.footer}>
      <HorizontalLine />

      <div className={styles.content}>
        <div className={styles.section}>
          <PuiTypography size={isMobile ? 14 : 16} color="gray-61">
            Copyright © 2025 All rights reserved
          </PuiTypography>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
